import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import Header from '@/components/Header';
import useStore from '@/store';

function HomeLayout({ variant }: { variant?: 'default' | 'stage' }): ReactElement {
  const { t } = useTranslation();
  const { selectedSubject } = useStore();
  const headerTitle = selectedSubject ? selectedSubject.name : `${t('selectSubject')}`;
  return (
    <Header
      headerTitle={headerTitle}
      showBack={!!selectedSubject}
      showCoins
      variant={variant}
      backLabel={variant === 'stage' ? headerTitle : undefined}
      showStudentCard={variant !== 'stage'}
    >
      <Outlet />
    </Header>
  );
}

HomeLayout.defaultProps = { variant: undefined };

export default HomeLayout;
